import infinite from '../components/intersectionobserver'
import SvgIcon from '@/components/svgIcon'
import column from '@/components/column'
import myVideo from '@/components/myVideo'
import searchTag from '@/components/searchTag'
import http from '@/http/axios';
import api from '@/http/api';
import echoGroup from  '@/components/echoGroup'
import replyGroup from  '@/components/replyGroup'
import { Message , MessageBox, Button, dialog, upload, Loading, pagination, checkbox, input, Radio, RadioGroup, RadioButton, Select, Option, OptionGroup, Image } from 'element-ui';
import Tinymce from '@/components/Tinymce'
import Login from '@/components/login';
import myPagination from '@/components/mypagination'
import store from '../store'
import { getCookie, setCookie, delCookie } from '@/assets/js/cookies'
require('intersection-observer');
class myPlugins {
    constructor(){

    }
    install(Vue, options){
        Vue.use(Button).use(dialog).use(upload).use(pagination).use(checkbox).use(input).use(Radio).use(RadioButton).use(RadioGroup).use(Select).use(Option)
        .use(OptionGroup).use(Loading.directive).use(Image);
        Vue.component('infinite',infinite) 
        Vue.component('SvgIcon', SvgIcon);
        Vue.component('column', column);
        Vue.component('myVideo', myVideo);
        Vue.component('searchTag', searchTag);
        Vue.component('echoGroup', echoGroup);
        Vue.component('replyGroup', replyGroup);
        Vue.component('Tinymce', Tinymce);
        Vue.component('myPagination', myPagination);
        
        Vue.prototype.$msgbox = MessageBox;
        Vue.prototype.$alert = MessageBox.alert;
        Vue.prototype.$message = Message;
        Vue.prototype.$loading = Loading.service;
        Vue.prototype.$http = http;
        Vue.prototype.$api = api;
        Vue.prototype.$getCookie = getCookie;
        Vue.prototype.$setCookie = setCookie;
        Vue.prototype.$delCookie = delCookie;
        let temp = Vue.extend(Login);

        let $vm = new temp({
            store
        });
        let $el = $vm.$mount().$el;
        document.body.appendChild($el);
        Vue.prototype.$isLogin = ()=>{
            let uid = getCookie('cy_uid');
            if(!uid){
                $vm.mask = true;
            }
            return uid;
        };
        Vue.prototype.$showLogin = () => {
            $vm.status = 'reset';
            $vm.mask = true;
        }


        Vue.prototype.$debounce = (context,fn,delay=300,content)=>{
            clearTimeout(fn.timerId)
            fn.timerId = setTimeout(()=>{
                fn.call(context,content)
            },delay)
        }

        Vue.directive('scroll', (el,binding,vnode,oldVnode) => {
            let handler  = binding.value.handler;
            let io = new IntersectionObserver( (entries)=>{
                // entries 对象数组   observer 实例
                if(entries[0].intersectionRatio <= 0 )return
                handler && handler();
            })
            io.observe(el)
        })
        Vue.directive('imgLoading', (el,binding,vnode,oldVnode) => {
           // let { src, limit, index }  = binding.value 无法解决下面问题 改为第二版
           // limit 告知 本el是否直接加载，不经过视图判断
            let { src, limit }  = binding.value
            if(typeof src !='string'||!src) throw new Error('请传入src')
            function srcLoad(io,el){
                let img = new Image();
                img.onload = () => {
                    el.src = src; //做了预加载 所以再回调中执行 不然提前去除可能会不执行src的添加
                    io.unobserve(el);
                }
                img.src = src;
            }
            let io = new IntersectionObserver( (entries,observer)=>{
                if(limit) srcLoad(io,el) 
                //请控制自己的视图，如果limit过小，会出现视图中图片未加载问题，IntersectionObserver 接口第一次渲染不能监控，所有intersectionRatio都是0，requestIdleCallback机制问题
                // 无限滚动 如果滚动较慢又会出现一种情况 就是index必然大于limit,
                //但是是渲染到可视界面中的，第一次渲染监控不到比如为0，滑动速度快不存在这种问题，这种现象主要存在于瀑布流部分列表已经渲染，未渲染的在可视区域中 
                // 本身通过limit控制也是来提前渲染而不是 懒加载  现在插件中 暂时不知道怎么去解决，现有方案是list中 item加字段来控制limit渲染 把item.limit传过来是否提前渲染
                // 获取数据之后 遍历一次把list前几个添加字段
                if(entries[0].intersectionRatio <= 0 )return
                if(src){
                  return  srcLoad(io,el)
                }
                return io.unobserve(el);
            })
            io.observe(el)
        })
    }

}
export default new myPlugins